import { position2dSchema, scale2dSchema, sideSchema } from '@/domain/shared/commonSchemas';
import { boolean, number, object, string, type InferType } from 'yup';

// Local size schema — optional at the field level but inner width/height required when given.
const optionalSize2dSchema = object({
    height: number().required(),
    width: number().required(),
})
    .default(undefined)
    .nullable();

const imageBehaviorSchema = object({
    alwaysOnTop: boolean().optional(),
    constrainToFrameX: boolean().optional(),
    fitToFrameHeight: boolean().optional(),
    hideControls: boolean().optional(),
    lockY: boolean().optional(),
})
    .default(undefined)
    .optional();

const imageFieldSchema = object({
    behavior: imageBehaviorSchema,
    filename: string().optional(),
    frameSize: optionalSize2dSchema,
    hasQualityWarning: boolean().required(),
    id: string().required(),
    isLocked: boolean().required(),
    kind: string()
        .oneOf(['image'] as const)
        .required(),
    opacity: number().min(0).max(1).required(),
    position: position2dSchema,
    rotationDeg: number().required(),
    scale: scale2dSchema,
    side: sideSchema,
    size: optionalSize2dSchema,
    uploadType: string()
        .oneOf(['cutPath', 'helpGrid', 'user'] as const)
        .required(),
    url: string().optional(),
    uuid: string().optional(),
});

type TImageFieldJSONData = InferType<typeof imageFieldSchema>;

export { imageFieldSchema };
export type { TImageFieldJSONData };
